import { DatePicker, Form, Modal } from "antd";
import { Calendar, AlertTriangle, X } from "lucide-react";
import IMAGES from "../../../constants/images";
import dayjs from "dayjs";
import FormItem from "antd/es/form/FormItem";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { editUnavialable } from "../../../redux/action/Appointment";

const EditUnPopUp = ({
  isOpen,
  onClose,
  time,
  editDialog,
  setEditDialog,
  slotID,
  reason,
}) => {
  const [startDate, endDate] = time?.split(" to ") || [];
  const [start, setStart] = useState(startDate ? dayjs(startDate) : null);
  const [end, setend] = useState(endDate ? dayjs(endDate) : null);
  const dispatch = useDispatch();
  const onChangeStart = (date) => {
    setStart(date); // could be dayjs or null
  };

  const onChangeEnd = (date) => {
    setend(date); // could be dayjs or null
  };
  const updateUnavailable = () => {
    const payload = {
      unAvailableRequest: [
        {
          scheduleId: slotID,
          unaAvailableStartDate: dayjs(start).format("YYYY-MM-DD"),
          unaAvailableEndDate: dayjs(end).format("YYYY-MM-DD"),
          reason: reason,
        },
      ],
    };
    dispatch(editUnavialable(payload));
    onClose(false);
  };
  return (
    <Modal
      open={isOpen}
      onCancel={() => onClose(false)}
      footer={null}
      width={480}
      centered
      closeIcon={<X className="w-6 h-6 text-gray-700" />}
      className="manage-slot-modal"
      maskStyle={{ backgroundColor: "rgba(55, 65, 81, 0.9)" }}
      bodyStyle={{ padding: 0 }}
    >
      <div className="relative transform scale-[0.9] origin-top-left w-[111.11%]">
        <div className="p-0 pt-8 flex flex-col items-center">
          {/* Calendar icon */}
          <div className="w-24 h-24 rounded-full bg-blue-50 flex items-center justify-center mb-2">
            <div className="w-16 h-16">
              <img src={IMAGES.manage_unavailable} />
            </div>
          </div>

          {/* Title */}
          <h2 className="text-[24px] font-poppins  font-semibold text-[#4B61FF] mb-6 text-center">
            Edit unavailability
          </h2>

          {/* Divider */}
          <div className="w-full h-px bg-gray-200 mb-6"></div>

          {/* Time slot info */}
          <p className="text-[#171717] font-poppins font-semibold text-[18px]  mb-2">
            You will become available for appointments during:
          </p>
          <div className="flex  items-center justify-center gap-2 mb-4">
            <Calendar className="w-5 h-5 text-gray-500" />
            <span className="font-normal text-[#171717] font-poppins text-[16px]">
              {time}
            </span>
          </div>

          {/* Divider */}
          <div className="w-full h-px bg-gray-200 mb-6"></div>

          {/* Warning message */}
          <div className="bg-[#EFF6FF] p-2 rounded-md flex justify-center items-center gap-3 mb-6 w-full">
            <div className="h-full">
              <DatePicker
                value={start}
                onChange={onChangeStart}
                placeholder="Start Date"
              />
            </div>
            <div className="h-full">
              <DatePicker
                value={end}
                onChange={onChangeEnd}
                placeholder="End Date"
              />
            </div>
          </div>

          {/* Action buttons */}
          <div className="flex gap-4 w-full">
            <button
              className="flex-1 py-3 border border-gray-300 rounded-md font-medium bg-[#ffffff] text-[#171717] border-[989898] font-poppins"
              onClick={() => {
                onClose();
                setEditDialog(!editDialog);
              }}
            >
              Cancel
            </button>
            <button
              className="flex-1 py-3 btn-gradient text-white rounded-xl font-poppins"
              onClick={() => {
                // setEditDialog(true);
                updateUnavailable();
              }}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditUnPopUp;
